module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.e464088.woff";